<template>
    <div class="image-loader-container">
        <img class="placeholder" :src="placeholder" alt="" v-if="!everythingDone">
        <img :style="{ opacity: imageLoader ? 1 : 0, transition: `${duration}ms` }" @load="LoadFinish" class="origin"
            :src="src" alt="">

    </div>
</template>

<script>
//测试用两组图片
//https://images.pexels.com/photos/33109/fall-autumn-red-season.jpg?w=100
//https://images.pexels.com/photos/33109/fall-autumn-red-season.jpg?fit=crop&crop=entropy&w=3456&h=2304
export default {
    props: {
        src: {
            type: String
        },
        placeholder: {
            type: String
        },
        duration: {
            type: Number,
            default: 3000
        }
    },
    data() {
        return {
            imageLoader: false,
            everythingDone: false
        }
    },
    methods: {
        LoadFinish() {
            this.imageLoader = true
            setTimeout(() => {
                this.everythingDone = true;
                //图片加载完成抛出事件
                this.$emit('load')
            }, this.duration)
        }
    }
}
</script>

<style lang="less">
.image-loader-container {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;

    img {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
    }

    .placeholder {
        filter: blur(2vw);
    }
}
</style>